module.exports = __webpack_public_path__ + "static/media/verified.16a7fee1.svg";